if (!customElements.get('jkl-regios-on-sale-badge')) {
  class JklRegiosOnSaleBadge extends HTMLElement {
    async connectedCallback() {
      // Se c'è già uno sconto nativo Shopify, il badge è già gestito dal Liquid
      if (this.dataset.hasNativeDiscount === 'true') return;

      // In PLP, jkl-plp-discounts.js pilota questo badge in un unico passaggio (una sola chiamata
      // API condivisa), quindi qui evitiamo la valutazione indipendente per non duplicare il lavoro.
      if (window.JKL?.isManagedDiscountCard?.(this)) return;

      await this.waitRegiosDOPP();
      await this.render();
    }

    waitRegiosDOPP() {
      return new Promise((resolve) => {
        if (window.RegiosDOPP?.api?.v0) {
          resolve();
        } else {
          window.addEventListener('regios-dopp:api-initialized', () => resolve(), { once: true });
        }
      });
    }

    async render() {
      try {
        const { salePrice, regularPrice } = await window.RegiosDOPP.api.v0.calculateDiscountedPrices({
          productId: parseInt(this.dataset.productId),
          variantId: parseInt(this.dataset.variantId),
          regularPriceInCents: parseInt(this.dataset.regularPrice)
        });

        // Prodotti con badge "exclusive promo": la chiamata sopra resta necessaria (pilota lo sconto
        // sul prezzo, es. in PDP), ma non mostriamo la label per non duplicarla con l'exclusive promo.
        if (this.dataset.suppressBadge === 'true') return;

        // Nessuno sconto Regios attivo
        if (!salePrice || salePrice.amount >= regularPrice.amount) return;

        // Se il cliente ha un tier, mostra il badge Regios solo se è >= allo sconto tier.
        // Se Regios è meno conveniente del tier, il tier badge gestisce la visualizzazione.
        const tierPercent = parseFloat(this.dataset.tierPercent || '0');
        if (tierPercent > 0) {
          const tierSaleAmount = regularPrice.amount * (1 - tierPercent / 100);
          if (salePrice.amount > tierSaleAmount) return;
        }

        const badgeText = this.buildBadgeText(salePrice, regularPrice);
        this.innerHTML = `<on-sale-badge class="badge badge--on-sale">${badgeText}</on-sale-badge>`;
        this.style.display = '';
      } catch (e) {
        // In caso di errore, mantieni nascosto
      }
    }

    buildBadgeText(salePrice, regularPrice) {
      if (this.dataset.discountMode === 'percentage') {
        const percent = Math.round((regularPrice.amount - salePrice.amount) / regularPrice.amount * 100);
        return `- ${percent}%`;
      }

      // Modalità importo: formatta la differenza risparmiata
      const savedAmount = regularPrice.amount - salePrice.amount;
      const moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      return `- ${this.formatMoney(savedAmount, moneyFormat)}`;
    }

    formatMoney(cents, format) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, format);
      }
      return (cents / 100).toFixed(2);
    }
  }

  customElements.define('jkl-regios-on-sale-badge', JklRegiosOnSaleBadge);
}
